// removed by extract-text-webpack-plugin
module.exports = {"container":"g9_g","heading":"g9_i","header":"g9_bg pKdTL18pM3P4XKY2kq_Ub","review":"g9_ha pKdTL18pM3P4XKY2kq_Ub","race":"g9_hb","bookNow":"g9_hc"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventHeader/styles.module.css
// module id = 1290
// module chunks = 27